import React from "react";
import { useParams, useNavigate } from "react-router-dom";

// ✅ You can later replace this array with an API fetch
const blogPosts = [
  {
    id: 1,
    title: "Luxury Living in Mumbai: Top 5 Sea-Facing Residences",
    image: "/images/BANNER/1.jpg",
    date: "Nov 5, 2025",
    author: "Ajahar Shaikh",
    excerpt:
      "Explore the most prestigious sea-view apartments redefining luxury living in South Mumbai. From Worli to Mahalaxmi, discover the city's finest addresses...",
    content: `South Mumbai has always been a symbol of luxury living. Projects along the sea-facing belt offer unmatched views and lifestyle. 
    These homes come with world-class amenities, private decks, and designer interiors — perfect for those who want elegance and exclusivity.`,
  },
  {
    id: 2,
    title: "How to Choose the Right Real Estate Investment in 2025",
    image: "/images/BANNER/2.jpg",
    date: "Oct 25, 2025",
    author: "Team RealtyPro",
    excerpt:
      "Investing in property can be a great way to build wealth. Here's how to identify promising locations, evaluate developers, and maximize ROI...",
    content: `In 2025, the real estate market is evolving with new infrastructure and government policies. 
    Focus on connectivity, trusted developers, and sustainable projects to ensure long-term value and higher returns.`,
  },
  {
    id: 3,
    title: "Benefits of Owning a Home in Vile Parle (W)",
    image: "/images/BANNER/3.jpg",
    date: "Sep 30, 2025",
    author: "Realty Insights",
    excerpt:
      "From excellent connectivity to peaceful living, here’s why Vile Parle (W) remains one of Mumbai’s most sought-after residential destinations...",
    content: `Vile Parle (W) offers the perfect balance of connectivity and calm. 
    With top schools, great markets, and proximity to the airport, it remains a family-friendly neighborhood that retains its charm.`,
  },
];

const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Find blog by ID (convert param to number)
  const blog = blogPosts.find((post) => post.id === parseInt(id));

  if (!blog) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-gray-700">
        <p className="text-lg mb-4">Blog not found 😕</p>
        <button
          onClick={() => navigate("/blogs")}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          Back to Blogs
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* <button
        onClick={() => navigate("/blogs")}
        className="text-blue-600 hover:text-blue-800 font-medium mb-4"
      >
        ← Back to Blogs
      </button> */}

      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-80 object-cover bg-gray-100 overflow-hidden"
        />
        <div className="p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            {blog.title}
          </h1>
          <p className="text-gray-500 text-sm mb-4">
            {blog.date} • {blog.author}
          </p>
          <p className="text-gray-700 text-base leading-relaxed text-justify mb-6">
            {blog.excerpt}
          </p>
          <p className="text-gray-700 text-base leading-relaxed text-justify whitespace-pre-line">
            {blog.content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogDetails;